import { withMotionMax } from '@hoc/withMotionMax';
import TestimonialCarousel from '@stories/Components/Misc/TestimonialCarousel/TestimonialCarousel';
import * as React from 'react';
import S from './Testimonials.styles';
const Testimonials = (props) => {
    return (React.createElement(S.Container, { id: props.id, theme: props.theme },
        React.createElement(TestimonialCarousel, { items: props.testimonials, title: props.title })));
};
export default withMotionMax(Testimonials);
